
@if (currentDay()) {
  <section class="route-day__container">
    <p class="ci-heading-h2-s-bold route-day__title">
      {{ currentDay() }}
    </p>
  </section>
}
